// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"632":"5c72ef46","678":"8c2d1a7a","808":"f024ffb5"}[chunkId] + ".js";
};